import React from 'react'

const ChatIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      d="M6.59744 0C2.95362 0 0 2.95362 0 6.59777C0 10.2133 2.90867 13.1479 6.5132 13.1932V16L11.0214 11.4922C12.3565 10.2849 13.1955 8.53922 13.1955 6.59777C13.1949 2.95362 10.2409 0 6.59744 0Z"
      fill="#052351"
    />
  </svg>
)

export default ChatIcon
